<span [class]="iconClass()" [ngStyle]="{ 'font-size': fontSize() }">
  <ng-content />

  @if (tooltip()) {
    <span class="tooltip-text" data-testid="tooltip">{{ tooltip() }}</span>
  }
</span>
